export default __webpack_public_path__ + "static/media/book.9dd62291.svg";